// extracted by mini-css-extract-plugin
export var cell = "_6j-4";
export var headerCell = "_6j-2";
export var rowHeader = "_6j-3";
export var table = "_6j-1";
export var tableContainer = "_6j-0";